import { render, staticRenderFns } from "./TermsAndConditionsVpc.vue?vue&type=template&id=d54a41dc"
import script from "./TermsAndConditionsVpc.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsVpc.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsVpc.vue?vue&type=style&index=0&id=d54a41dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports